import { Components, Theme } from '@mui/material';

const MuiTab: Components<Theme>['MuiTab'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.grey[500],
      fontSize: theme.fontSizes.regular,
      fontWeight: theme.typography.fontWeightRegular,
      lineHeight: '150%',
      padding: theme.spacing(theme.spacingSizes.sm, theme.spacingSizes.lg),
      textTransform: 'none',

      '&.Mui-selected': {
        color: theme.palette.grey[900],
        fontWeight: theme.typography.fontWeightMedium,
        borderColor: theme.palette.grey[900],
      },
    }),
  },
};

export default MuiTab;
